<template>
  <a-range-picker v-model="newVal" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import moment from 'moment'

export default {
  name: 'VRangePicker',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Object, Number, Array],
      default() {
        return []
      }
    },
    timeStamp: {
      type: Boolean,
      default: true
    },
    isDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newVal: {
      get() {
        let arr = []
        if (this.value[0] && typeof this.value[0] === 'number') {
          this.value.forEach((o, idx) => {
            arr.push(moment(this.value[idx] * 1000))
          })
        }
        arr = arr.length ? arr : this.value
        return arr
      },
      set(val) {
        const arr = []
        val.forEach((o, i) => {
          if (o && typeof o !== 'number') {
            this.isDate
            ? i === 0
            ? arr.push(Number(moment(o).startOf("day").format('X')))
            : arr.push(Number(moment(o).endOf("day").format('X')))
            : arr.push(moment(o).unix())
          }
        })
        this.$emit('input', arr)
      }
    }
  }
}
</script>
